<widget-card [cardTitle]="config.translations.widgetTitle"><list-of-contacts [displayTitle]="true" /></widget-card>
